class StandardError extends Error {
  status: number
  body: Record<string, unknown>

  constructor(
    message = 'Standard CounselPro Error',
    status = 500,
    body: Record<string, unknown> = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default StandardError
